export default {"src":"/_next/static/media/review-source-rove.6afb9a24.svg","height":16,"width":68};